import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo, getTsDate } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { AppUnit, SelectOption, IUser } from '../../../globals/interfaces';
import useTypedForm from '../../../components/custom/hookForm/useTypedForm';
import Select from 'react-select';
import _ from 'lodash';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { UpdateApp } from '.';

const DISPLAY_SETTINGS = [
    'Queue',
    'Dock',
    'Temp Control',
    'Device Status'
]

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    item: AppUnit | undefined;
    updateApp: UpdateApp;
    user: IUser;
}

export default function ModalManage ({
    modal,
    setModal,
    item,
    updateApp,
    user
}: Props) {

    const {
        formState: {
            errors,
            isValid
        },
        handleSubmit,
        trigger,
        reset, 
        watch,
        setValue,
        FormInput
    } = useTypedForm<AppUnit>({
        mode: 'all',
        resolver: yupResolver(yup.object().shape({
            appName: yup.string().required(),
            displaySetting: yup.string().notRequired().nullable().when('appType', {
                is: 'DISPLAY',
                then: yup.string().required()
            })
        }))
    });

    useEffect(() => {
        if (!item) return;
        const initialValues = _.cloneDeep(item);
        initialValues.modifiedAt = getTsDate();
        initialValues.modifiedBy = user.s_email;
        reset(initialValues);
        trigger();
    }, [item]);

    const displaySetting = watch('displaySetting');


    const toggle = () => setModal(!modal);

    if (!item) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Manage App {displaySetting}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormInput 
                    name={'appName'}
                    label='Name'
                />
                {
                    item.appType === 'DISPLAY' && (
                        <Select 
                            options={DISPLAY_SETTINGS.map(item => ({
                                label: item,
                                value: item
                            }))}
                            onChange={(option: SelectOption) => setValue('displaySetting', String(option.value), {
                                shouldValidate: true,
                                shouldTouch: true
                            })}
                            value={{
                                label: displaySetting,
                                value: displaySetting
                            }}
                        />
                    )
                }
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(item)}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={handleSubmit(updateApp)} 
                            disabled={!isValid}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;